var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackChest(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 47,
    height: 82,
    viewBox: "0 0 47 82",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.15431 35.6861C3.74941 34.7129 8.27045 21.5421 3.28277 1.25575C3.21808 0.992624 3.47869 0.75803 3.73161 0.855269C9.84121 3.20428 25.4378 6.1211 43.191 0.786341C43.4399 0.711543 43.6796 0.935309 43.6122 1.18633C41.4594 9.20509 39.0209 26.0882 46.0624 35.6861C45.7346 36.0139 45.0166 36.8007 44.7544 38.6365C44.4265 40.9312 42.1318 51.0936 43.4431 60.6004C44.0987 61.9117 44.8855 64.4687 44.0987 70.7628C43.9894 71.3092 45.6067 75.2212 45.0822 77.3192C44.4265 79.9418 12.9558 83.5478 2.7934 77.647C2.90267 76.2265 2.72786 72.3364 2.4656 70.7628C2.13778 68.7959 1.48214 66.829 3.12124 60.6004C4.43252 55.6176 3.01197 43.8816 2.13778 38.6365C1.80996 37.653 1.1511 35.3583 1.15431 35.6861Z",
    stroke: "#202E5F",
    strokeWidth: 0.65564
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackChest);
export default __webpack_public_path__ + "static/media/BackChest.3cd1ab80c81f9175c22f217ca43aa8d0.svg";
export { ForwardRef as ReactComponent };